module.exports = __webpack_public_path__ + "images/init-new-projects-9d054e0c39ce9db4b3a8d4164fb4d8e4.png";